<template>
	<b-row>
		<b-col cols="12" lg="8">
			<Overview />
		</b-col>
		<b-col cols="12" lg="4">
			<DisbursementCard />
			<CollectionCard />
			<RedemptionCard />
		</b-col>
	</b-row>
</template>

<script>
import Overview from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Overview/Overview';
import DisbursementCard from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Overview/Disbursement'
import CollectionCard from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Overview/Collection'
import RedemptionCard from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Overview/Redemption'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	components: {
		Overview,
    DisbursementCard,
    CollectionCard,
    RedemptionCard
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
		is_deleted(){
			return !_gHlp.isEmpty(this.activeCase.deleted_at);
		}
  },
}
</script>